import * as React from 'react'
import type { SVGProps } from 'react'
const SvgGamepad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 7.25a.75.75 0 0 1 .75.75v1.25H10a.75.75 0 1 1 0 1.5H8.75V12a.75.75 0 0 1-1.5 0v-1.25H6a.75.75 0 0 1 0-1.5h1.25V8A.75.75 0 0 1 8 7.25M17 11.75a1 1 0 1 0-2 0V12a1 1 0 0 0 2 0zM16 7a1 1 0 0 1 1 1v.25a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1M19 10a1 1 0 0 1-1 1h-.25a1 1 0 0 1 0-2H18a1 1 0 0 1 1 1M14.25 11a1 1 0 1 0 0-2H14a1 1 0 0 0 0 2z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.75 3a.75.75 0 1 0-1.5 0v1.487q-2.159.03-4.312.229l-.332.03a4.71 4.71 0 0 0-4.274 4.61l-.012.713a43 43 0 0 0 .672 8.328 2.86 2.86 0 0 0 2.814 2.353h.221a3.12 3.12 0 0 0 2.856-1.857l1.06-2.392c.792-1.783 3.323-1.783 4.114 0l1.06 2.392a3.12 3.12 0 0 0 2.856 1.857h.221a2.86 2.86 0 0 0 2.814-2.353 43 43 0 0 0 .672-8.328l-.012-.713a4.71 4.71 0 0 0-4.274-4.61l-.332-.03a55 55 0 0 0-4.312-.23zM7.076 6.21a53.4 53.4 0 0 1 9.848 0l.332.03a3.21 3.21 0 0 1 2.912 3.141l.012.713a41.5 41.5 0 0 1-.648 8.037 1.36 1.36 0 0 1-1.338 1.119h-.221a1.62 1.62 0 0 1-1.484-.965l-1.06-2.392c-1.32-2.972-5.538-2.972-6.857 0l-1.06 2.392c-.26.587-.843.965-1.485.965h-.22a1.36 1.36 0 0 1-1.339-1.119 41.4 41.4 0 0 1-.648-8.036l.012-.714A3.21 3.21 0 0 1 6.745 6.24z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGamepad
